import { useQuery } from "@tanstack/react-query";
import { runsPage } from "@/api/runs";

export function RunPicker({
  value,
  onChange,
}: {
  value: string | undefined;
  onChange: (next: string | undefined) => void;
}) {
  const runs = useQuery({
    queryKey: ["runs", "picker"],
    queryFn: () => runsPage(null, { limit: 200 }),
    staleTime: 30_000,
  });

  return (
    <select
      className="input w-56"
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value || undefined)}
    >
      <option value="">Any run</option>
      {(runs.data?.items ?? []).map((r) => (
        <option key={r.id} value={r.id}>
          {r.source} · {r.status} · {new Date(r.started_at).toLocaleDateString()}
        </option>
      ))}
    </select>
  );
}
